/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const UploadStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 13.6001L12 3.0001M16.5 7.43941L12.5437 3.32311C12.3534 3.1251 12.2582 3.02609 12.1485 2.989C12.052 2.95637 11.948 2.95637 11.8515 2.989C11.7418 3.02609 11.6466 3.1251 11.4563 3.32311L7.5 7.43941M4 13.5L4 15.2C4 16.8802 4 17.7202 4.32698 18.362C4.6146 18.9265 5.07354 19.3854 5.63803 19.673C6.27976 20 7.11984 20 8.8 20L15.2 20C16.8802 20 17.7202 20 18.362 19.673C18.9265 19.3854 19.3854 18.9265 19.673 18.362C20 17.7202 20 16.8802 20 15.2L20 13.5"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { UploadStrokeIcon };
